<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="面值" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.coupon_price }}
				  </template>
				</el-table-column>
				<el-table-column label="数量" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.total_count }}
				  </template>
				</el-table-column>
				<el-table-column label="剩余数量" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.remain_count }}
				  </template>
				</el-table-column>
				<el-table-column label="最小使用金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.use_min_price }}
				  </template>
				</el-table-column>
				<el-table-column label="使用开始时间" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.limit_start_time }}
				  </template>
				</el-table-column>
				<el-table-column label="使用结束时间" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.limit_end_time }}
				  </template>
				</el-table-column>
				<el-table-column label="领取开始时间" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.start_time }}
				  </template>
				</el-table-column>
				<el-table-column label="领取结束时间" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.end_time }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="60" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.utime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
		    <el-form-item label="优惠券名称" prop="name">
		      <el-input v-model="form.name" placeholder="请输入优惠券名称" type="text" clearable />
		    </el-form-item>
		    <el-form-item label="面值" prop="coupon_price">
		      <el-input v-model="form.coupon_price" placeholder="请输入面值" type="number" clearable />
		    </el-form-item>
		    <el-form-item label="数量" prop="total_count">
		      <el-input v-model="form.total_count" placeholder="请输入数量" type="number" clearable />
		    </el-form-item>
			<el-form-item label="剩余数量" prop="remain_count" v-if="form.id">
			  <el-input v-model="form.remain_count" placeholder="请输入剩余数量" type="number" clearable />
			</el-form-item>
			<el-form-item label="最低消费金额" prop="use_min_price">
			  <el-input v-model="form.use_min_price" placeholder="请输入最低消费金额" type="number" clearable />
			</el-form-item>
			<el-form-item label="使用时间" prop="sy_time">
			  <el-date-picker
				 v-model="form.sy_time"
				 value-format="yyyy-MM-dd"
				 type="daterange"
				 range-separator="至"
				 start-placeholder="开始日期"
				 end-placeholder="结束日期"
				 @input="syTimeChange">
			  </el-date-picker>
			</el-form-item>
			<el-form-item label="领取时间" prop="lq_time">
			  <el-date-picker
				 v-model="form.lq_time"
				 value-format="yyyy-MM-dd"
				 type="daterange"
				 range-separator="至"
				 start-placeholder="开始日期"
				 end-placeholder="结束日期"
				 @input="lqTimeChange">
			  </el-date-picker>
			</el-form-item>
			<el-form-item label="说明" prop="desc">
			  <el-input v-model="form.desc" placeholder="请输入说明" type="text" clearable />
			</el-form-item>
		    <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		    </el-form-item>
			<el-form-item label="排序" prop="sort">
			  <el-input v-model="form.sort" placeholder="请输入排序" type="number" clearable />
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'coupon',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					name:'',
					coupon_price:'',
					total_count:0,
					use_min_price:0,
					sy_time:[],
					lq_time:[],
					desc:'',
					status:1,
					sort:100,
				},
				rules:{
					name: [
					  { required: true, message: '请输入优惠券名称', trigger: 'blur' }
					],
					total_count: [
					  { required: true, message: '请输入优惠券数量', trigger: 'blur' }
					],
					coupon_price: [
					  { required: true, message: '请输入优惠券面值', trigger: 'blur' }
					],
					sy_time: [
					  { required: true, message: '请输入优惠券使用时间', trigger:['blur','change']}
					],
					lq_time: [
					  { required: true, message: '请输入优惠券领取时间', trigger:['blur','change']}
					],
				},
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
				   name:'',
				   coupon_price:'',
				   total_count:0,
				   use_min_price:0,
				   sy_time:[],
				   lq_time:[],
				   desc:'',
				   status:1,
				   sort:100,
			  }
			  this.resetForm('form')
			},
			handleEdit(row) {
			  this.reset()
			  this.open = true
			  this.title = '编辑'
			  this.form = JSON.parse(JSON.stringify(row))
			  this.form.sy_time = [this.form.limit_start_time,this.form.limit_end_time]
			  this.form.lq_time = [this.form.start_time,this.form.end_time]
			},
			syTimeChange(e){
				this.$forceUpdate()
			},
			lqTimeChange(e){
				this.$forceUpdate()
			}
		}
	}
</script>

<style>
</style>